import { getOrderTotalAmount } from 'components/LightConversation/utils/order';
import { formatNumber } from 'utils/numberFormat';
import { useTranslate } from '@tolgee/react';

export const Total = ({ order }: { order: Conversation.Trade.Vo }) => {
  const { unit } = order;
  const { t } = useTranslate();
  const orderTotalAmount = getOrderTotalAmount(order);

  return (
    <div className="flex items-center justify-between">
      <div className="text-[16px] font-medium text-[var(--fett-text-primary)]">
        {t('trade.买家实付金额')}
      </div>
      <div className="text-[18px] font-medium text-[var(--fett-text-primary)]">
        {unit} {formatNumber(orderTotalAmount, '0,0.00')}
      </div>
    </div>
  );
};
